import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { Dialog, FlatButton } from "material-ui"
import { ISchedulePatternTemplate, IScheduleDocument } from "../../../models"
import DayTimelineBar from "../../../components/schedule/DayTimelineBar"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import AssignEmployeeSelectDays from "./AssignEmployeeSelectDays"
import _ from "lodash"
import { grey700 } from "material-ui/styles/colors"

interface IProps {
  schedule: IScheduleDocument
  unAssignPatternTemplate: ISchedulePatternTemplate
  handleClose(): void
  handleUnAssign(unAssignPatternTemplates: ISchedulePatternTemplate[]): void
}
interface IState {
  selectedDays: ISchedulePatternTemplate[]
}

export default class UnAssignEmployeeDialog extends React.Component<IProps, IState> {
  private assignedPatternTemplates: ISchedulePatternTemplate[]
  constructor(props: IProps) {
    super(props)
    this.state = {
      selectedDays: [props.unAssignPatternTemplate]
    }
    autobind(this)
    this.assignedPatternTemplates = scheduleHelper.getCopiedAssignedPTs(props.schedule, props.unAssignPatternTemplate)
  }

  render() {
    return (
      <Dialog
        open
        title={strings.Un_Assign_Employee}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            data-intercom-target={"UnAssignEmployeeDialog-Btn-CloseDialog"}
            label={strings.CANCEL}
            secondary
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"UnAssignEmployeeDialog-Btn-Save"}
            label={strings.OK}
            primary
            onClick={() => this.props.handleUnAssign(this.state.selectedDays)}
          />
        ]}
      >
        <div style={{ marginTop: 20, paddingRight: 20, paddingLeft: 20 }}>
          <div style={{ marginBottom: 20, color: grey700, fontSize: 18 }}>
            {strings.formatString(strings.Are_you_sure_you_want_to_un_assign_employee_x_for_selected_days, this.props.unAssignPatternTemplate.AssignedUserName)}
          </div>
          <AssignEmployeeSelectDays
            availableDays={this.assignedPatternTemplates}
            fixedDay={this.props.unAssignPatternTemplate}
            selectedDays={[this.props.unAssignPatternTemplate]}
            handleSelectDays={selectedDays => this.setState({ selectedDays })}
          />
          <div style={{ height: 150 }}>
            <div style={{ color: "rgb(97, 97, 97)", marginBottom: 10 }}>{strings.Shift_information}</div>
            <DayTimelineBar
              shiftTemplates={this.props.unAssignPatternTemplate.ShiftTemplates}
              totalWidth={888}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}